module.exports = __webpack_public_path__ + "media/images/cardboard-bg-02-bfd34b6019a49dc53efadad5a07dd109.svg";